import { render, staticRenderFns } from "./InspirationSites.vue?vue&type=template&id=15081a6c&scoped=true"
import script from "./InspirationSites.vue?vue&type=script&lang=js"
export * from "./InspirationSites.vue?vue&type=script&lang=js"
import style0 from "./InspirationSites.vue?vue&type=style&index=0&id=15081a6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15081a6c",
  null
  
)

export default component.exports